(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["playback-shop-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.matches('[data-pb-navigation-details]') || !opened.open) return;
    document.querySelectorAll('[data-pb-navigation-details][open]').forEach((details) => {
      if (details !== opened) details.open = false;
    });
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const details = event.target.closest('[data-pb-navigation-details][open]');
    if (!details) return;
    details.open = false;
    details.querySelector('summary').focus();
    event.preventDefault();
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-pb-navigation-details][open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('[data-pb-navigation-details][open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
